import React from 'react';
import { FaFacebookSquare } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-green-600 text-white py-10 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        
        {/* Logo */}
        <div className="flex flex-col items-center md:items-start">
          <img 
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1744174245/J_Mills_Logo_Illustration_hinhst.png" 
            alt="J Mills Logo" 
            className="h-20 mb-4"
          />
          <p className="text-center md:text-left text-sm">
            Pure & Natural – Bringing you the finest oil since day one.
          </p>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-col items-center md:items-start space-y-2">
          <h3 className="font-bold text-lg mb-2">Quick Links</h3>
          <a href="#home" className="hover:underline hover:text-green-200">Home</a>
          <a href="#products" className="hover:underline hover:text-green-200">Products</a>
          <a href="#about" className="hover:underline hover:text-green-200">About Us</a>
          <a href="#contact" className="hover:underline hover:text-green-200">Contact Us</a>
        </div>

        {/* Contact Info */}
        <div className="space-y-2 text-center md:text-left">
          <h3 className="font-bold text-lg mb-2">Contact Us</h3>
          <p>
            <span className="font-semibold">Email:</span>{' '}
            <a href="mailto:info@jayamaloilmills.lk" className="underline hover:text-green-200">
            info@jayamaloilmills.lk
            </a>
          </p>
          <p>
            <span className="font-semibold">Phone:</span>{' '}
            <a href="tel:0332255693" className="underline hover:text-green-200">0332255693</a> /{' '}
            <a href="tel:0778540456" className="underline hover:text-green-200">0778540456</a>
          </p>
          <p>
            <span className="font-semibold">Address:</span> No. 567, Embaraluwa South, Weliweriya
          </p>
          <div className="flex items-center justify-center md:justify-start gap-2 pt-2">
            <FaFacebookSquare size={20} className="text-white" />
            <a
              href="https://www.facebook.com/share/193NDMTLkc/?mibextid=wwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-green-200"
            >
              Visit our Facebook page
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="mt-10 border-t border-green-400 pt-4 text-sm flex flex-col md:flex-row items-center justify-between gap-3">
        <p className="text-center md:text-left">&copy; {new Date().getFullYear()} Jayamal Oil Mills. All rights reserved.</p>
        
        {/* StackNet Credit */}
        <a 
          href="https://www.stacknet.lk/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="flex items-center gap-2 hover:text-green-200"
        >
          <span>Web design by</span>
          <img 
            src="https://res.cloudinary.com/dwf8ifbzs/image/upload/v1741405701/2Asset_2gf9_white_lojr1i.png" 
            alt="StackNet Logo" 
            className="h-6"
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;